import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { DrawerBodyWrapper } from '@base'
import { Pill, Table as TableV2 } from '@baseV2'
import { DISPATCH_PLAN_STATUS, strings } from '@constants'
import { getAllDispatchPlanCards } from '@data/conn/get/dispatchPlan'
import { formatDate } from '@utils'
import { paths } from '@routes'
import { displayItemWeight } from '../AddDispatchPlanV2'

const STATUS_PILL_COLORS = {
	[DISPATCH_PLAN_STATUS.ACTIVE]: 'info',
	[DISPATCH_PLAN_STATUS.COMPLETED]: 'success',
	[DISPATCH_PLAN_STATUS.SCHEDULED]: 'warning',
	[DISPATCH_PLAN_STATUS.RESCHEDULED]: 'warning',
	[DISPATCH_PLAN_STATUS.CLOSED]: 'neutral',
	[DISPATCH_PLAN_STATUS.CANCELLED]: 'error',
	[DISPATCH_PLAN_STATUS.DELETED]: 'error',
}

// The dispatches already created for a fulfillment plan, shown from the Create Dispatch page
const PreviousDispatches = ({ orderId, fulfillmentId }) => {
	const userId = useSelector((_state) => _state.getIn(['user', 'user', 'user_id']))
	const [cards, setCards] = useState([])
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		setLoading(true)
		getAllDispatchPlanCards(userId, 0, 1000, { orderIdFilter: orderId, fulfillmentIdFilter: fulfillmentId })
			.then((response) => setCards(response?.data ?? []))
			.catch(() => setCards([]))
			.finally(() => setLoading(false))
	}, [userId, orderId, fulfillmentId])

	const columns = useMemo(
		() => [
			{
				label: strings(['dispatch', 'plan', 'id']),
				key: (data) => data,
				renderer: (data) => (
					<Link
						to={paths.admin_manage_enquiry_order_edit_dispatch_plans_edit(data?.order_id ?? orderId, data?.dispatch_plan_id)}
						target='_blank'
						rel='noopener noreferrer'
					>
						{data?.dispatch_plan_id ?? '-'}
					</Link>
				),
				mobile: true,
				sortable: false,
			},
			{
				label: strings(['dispatch', 'quantity']),
				key: (data) => data,
				renderer: (data) => displayItemWeight(data?.total_allotted_weight, data?.input_type),
				mobile: true,
				sortable: false,
			},
			{
				label: strings(['dispatch', 'date']),
				key: 'plan_start_date',
				renderer: (data) => formatDate(data) || '-',
				mobile: true,
				sortable: false,
			},
			{
				label: strings('status'),
				key: 'status',
				renderer: (data) =>
					data ? (
						<Pill color={STATUS_PILL_COLORS[data] ?? 'neutral'} variant='subtle' round>
							{data}
						</Pill>
					) : (
						'-'
					),
				mobile: true,
				sortable: false,
			},
		],
		[orderId]
	)

	return (
		<DrawerBodyWrapper>
			<TableV2
				columns={columns}
				data={cards}
				loading={loading}
				rowsToDisplay={100}
				totalItemCount={cards.length}
				onPageChange={() => {}}
				rowClickable={false}
				hideFooter
				emptyState={{ text: strings('no_data_found') }}
			/>
		</DrawerBodyWrapper>
	)
}

export default PreviousDispatches
